import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { take } from 'rxjs/internal/operators/take';

@Component({
	selector: 'app-transcriptions-toolbar',
	standalone: true,
	imports: [MatToolbarModule, MatDividerModule, MatButtonModule, MatTooltipModule, MatIconModule, TranslateModule],
	templateUrl: './transcriptions-toolbar.component.html',
	styleUrl: './transcriptions-toolbar.component.scss'
})
export class TranscriptionsToolbarComponent implements OnChanges {
	@Input() selectedItems: any[] = [];
	@Input() totalItemsCount: number = 0;
	@Input() scrollToTop: boolean = false;
	@Output() actionRequested: EventEmitter<any> = new EventEmitter();

	constructor(private matDialog: MatDialog) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedItems']) {
			this.selectedItems = changes['selectedItems'].currentValue;
		}
	}

	checkValidity(type: 'DELETE') {
		switch (type) {
			case 'DELETE': {
				return this.selectedItems.length > 0;
			}
			default:
				return false;
		}
	}

	itemAction(action: 'DELETE' | 'UNSELECT_ALL' | 'SCROLL_TO_TOP') {
		switch (action) {
			case 'DELETE': {
				const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
					width: '600px',
					data: {
						type: 'delete-confirmation',
						mode: 'DELETE',
					},
				});

				dialogRef
					.afterClosed()
					.pipe(take(1))
					.subscribe(result => {
						if (result) {
							this.actionRequested.next({
								action: 'TOOLBAR',
								groupAction: action
							});
						}
					});
				break;
			}
			case 'UNSELECT_ALL': {
				this.actionRequested.next({
					action: 'UNSELECT_ALL',
				});
				break;
			}
			case 'SCROLL_TO_TOP': {
				this.actionRequested.next({
					groupAction: 'SCROLL_TO_TOP'
				});
				break;
			}
		}
	}

	scrollToTopAction() {
		this.actionRequested.emit({
			groupAction: 'SCROLL_TO_TOP'
		});
	}
}